import {BaseService} from './Core/BaseService';
import {BaseCachedService} from "./Core/BaseCachedService";

class ActivityTypeService extends BaseCachedService {
    get Url() { return super.Url + "/activityTypes"; }
    get ModelName() { return "Activity Type"; }
    get PrimaryKeyProperty() { return "activityTypeId"; }
    
    Get(contextNodeId = null) {
        if(contextNodeId) {
            return this.SendRequest(BaseService.GET, {contextNodeId});
        }
        return super.Get();
    }
}

export const service = new ActivityTypeService();

